import { render, staticRenderFns } from "./AccountPayableTax.vue?vue&type=template&id=147f518a&scoped=true"
import script from "./AccountPayableTax.vue?vue&type=script&lang=js"
export * from "./AccountPayableTax.vue?vue&type=script&lang=js"
import style0 from "./AccountPayableTax.vue?vue&type=style&index=0&id=147f518a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147f518a",
  null
  
)

export default component.exports